import action from 'desktop/utils/createAction';
import APP from 'desktop/epgTypes';

export default {
  handleCurrentProgramListUpdated: action(APP.EVENT_CURRENT_PROGRAM_LIST_UPDATED),
  handleCurrentProgramChanged: action(APP.EVENT_CURRENT_PROGRAM_CHANGED),
  handleActiveProgramChanged: action(APP.EVENT_ACTIVE_PROGRAM_CHANGED),
  handleChannelsReady: action(APP.EVENT_CHANNELS_READY),
  handleProgramsReady: action(APP.EVENT_PROGRAMS_READY),
  handleChannelSwitch: action(APP.EVENT_CHANNEL_SWITCH),
  handleFavoriteToggle: action(APP.EVENT_FAVORITE_TOGGLED),
  handleProgramSwitch: action(APP.EVENT_SWITCH_PROGRAM),
  handleRenderExtendedProgram: action(APP.EVENT_RENDER_EXTENDED_PROGRAM),
  handleCurrentChannelChanged: action(APP.EVENT_CURRENT_CHANNEL_CHANGED),
  handlePlayingProgramChanged: action(APP.EVENT_PLAYING_PROGRAM_CHANGED),
  handleSubscriptionInfoLoaded: action(APP.EVENT_SUBSCRIPTION_INFO_LOADED),
  handleAllChannelsButtonInfo: action(APP.ALL_CHANNELS_BUTTON_INFO),
  setCurrentChannelAbsoluteId: action(APP.SET_CURRENT_CHANNEL_ABSOLUTE_ID),
};
